import { AccommodationsPageLayout } from '@graphql/generated-base';
import type { AccommodationsSectionLayoutType } from '@shared/types/Accommodations.types';

const apiToFe: Readonly<Record<AccommodationsPageLayout, AccommodationsSectionLayoutType>> = {
  [AccommodationsPageLayout.MAP_AND_HOTEL_TILE]: 'default',
  [AccommodationsPageLayout.FLASHLIGHT]: 'flashlight',
  [AccommodationsPageLayout.SIDE_BY_SIDE_SIMPLE]: 'side_by_side_simple',
  [AccommodationsPageLayout.SIDE_BY_SIDE_ELEGANT]: 'side_by_side_elegant',
  [AccommodationsPageLayout.FULL_WIDTH_PHOTO]: 'full_width_photo',
  [AccommodationsPageLayout.TYPOGRAPHIC]: 'typographic',
  [AccommodationsPageLayout.STYLISH_HOVER]: 'stylish_hover',
};

const feToApi: Readonly<Record<AccommodationsSectionLayoutType, AccommodationsPageLayout>> = {
  default: AccommodationsPageLayout.MAP_AND_HOTEL_TILE,
  flashlight: AccommodationsPageLayout.FLASHLIGHT,
  side_by_side_simple: AccommodationsPageLayout.SIDE_BY_SIDE_SIMPLE,
  side_by_side_elegant: AccommodationsPageLayout.SIDE_BY_SIDE_ELEGANT,
  full_width_photo: AccommodationsPageLayout.FULL_WIDTH_PHOTO,
  typographic: AccommodationsPageLayout.TYPOGRAPHIC,
  stylish_hover: AccommodationsPageLayout.STYLISH_HOVER,
};

export const apiToSectionLayout = (api: AccommodationsPageLayout | null | undefined): AccommodationsSectionLayoutType => (api && apiToFe[api]) ?? 'default';

export const sectionLayoutToApi = (layout: AccommodationsSectionLayoutType): AccommodationsPageLayout => feToApi[layout];

// Single source of truth for valid FE layout values — derived from the mapper, so it
// stays in sync if a new variant is added to AccommodationsSectionLayoutType.
export const validSectionLayouts: ReadonlySet<AccommodationsSectionLayoutType> = new Set(Object.keys(feToApi) as AccommodationsSectionLayoutType[]);

export const isValidSectionLayout = (value: string | null | undefined): value is AccommodationsSectionLayoutType =>
  typeof value === 'string' && validSectionLayouts.has(value as AccommodationsSectionLayoutType);
